<div class="loader text-center" *ngIf="isLoading">
    <img src="../../../assets/images/31.svg">
  </div>
<div class="col-lg-11 col-md-12 mx-auto mt-4">
    <div class="search-filter-container">
        <div class="search-bar">
            <input type="text" placeholder="Search by Name" [formControl]="searchControl" />
            <span class="search-icon"><img class="lensImage"
                    src="../../../../assets/images/lens-icon.svg"></span>
        </div>

        <div class="filter-dropdown">
            <label for="category">Filter by Tier</label>&nbsp;&nbsp;
            <div class="custom-dropdown" (click)="toggleDropdown2($event); isOpen=false"  tabindex="0"
                (blur)="closeDropdown2()">
                <div class="selected">
                    {{ selectedOption2 }}
                    <span class="arrow"><img src="../../../../assets/images/up-arrow-svg.svg"
                            width="19"> </span>
                </div>
                <ul *ngIf="isOpen2" class="options">
                    <li (click)="currentPage=1; selectOption2($event, 'all');">All</li>
                    <li *ngFor="let option of tiers" (click)="currentPage=1; selectOption2($event, option);">
                        {{ option }}
                    </li>
                </ul>
            </div>
        </div>

        <div class="filter-dropdown">
            <label for="category">Filter by Charity Category</label>&nbsp;&nbsp;
            <div class="custom-dropdown" (click)="toggleDropdown($event); currentPage=1; isOpen2=false"  tabindex="0"
                (blur)="closeDropdown()">
                <div class="selected">
                    {{ selectedOption }}
                    <span class="arrow"><img src="../../../../assets/images/up-arrow-svg.svg"
                            width="19"> </span>
                </div>
                <ul *ngIf="isOpen" class="options">
                    <li (click)="currentPage=1; selectOption($event, 'all');">All</li>
                    <li *ngFor="let option of category" (click)="currentPage=1; selectOption($event, option)">
                        {{ option.name }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row g-3">
        <div class="col-6 col-md-4 col-lg-3" *ngIf="calledFrom=='insightsPage'">
            <div (click)="navigate('allOrg')" data-bs-dismiss="modal" class="org-card p-3 rounded bg-white d-flex flex-column">
        
                <div class="all-org-txt d-flex align-items-center justify-content-center">
                    Show Data for All Organizations
                </div>
            </div>
        </div>
        <div class="col-6 col-md-4 col-lg-3"  *ngFor="let org of organizations">
            <div (click)="navigate('org',org)" [title]="org.orgName + ', ' + org.orgCity + ', ' + org.orgState" data-bs-dismiss="modal" class="org-card p-3 rounded bg-white d-flex flex-column">

                <!-- Logo (centered with flex-grow) -->
                <div class="tierimage">
                    <img [src]="'../../../../assets/images/tier' + org.tier + '-icon.png'" alt="Tier">
                </div>
                <div class="open-icon-container">
                    <img class="open-icon-img" src="../../../../assets/images/open-org.png">
                </div>
                <div
                    class="flex-grow-1 logo-conatiner d-flex align-items-center justify-content-center position-relative">
                    <img [src]="org.orgLogo ? org.orgLogo : './../../../../assets/images/nopic.png'" alt="{{ org.orgName }}" class="org-logo img-fluid" />
                    <a href="#" class="external-link-icon" title="Visit Website">
                        <i class="bi bi-box-arrow-up-right"></i>
                    </a>
                </div>

                <!-- Name at the bottom -->
                <p class="org-name text-startr mt-2 mb-0">{{ org.orgName }}</p>

            </div>
        </div>
        <div *ngIf="organizations.length === 0" class="noData">No Data Found</div>
    </div><br>
    
    <app-pagenation *ngIf="organizations.length != 0" [totalPages]="totalPages" [currentPage]="currentPage" (pageChange)="onPageChange($event)">
    </app-pagenation>
    <br>

</div>
